import React, { useEffect } from "react";
import { PrintList } from "./PrintList";
import { useDispatch } from "react-redux";
import { getAllHpFileFetch } from "../../features/action/fetchHp";

const HP = () => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(getAllHpFileFetch());
  }, [dispatch]);
  return <PrintList />
}

export default HP